import { Injectable } from '@angular/core';
import { HardcodedLabels } from '@shared/constants/hardcoded-labels';

@Injectable()
export class HardcodedTranslationService {

    // Get hardcoded translation value
    public getHardcodedValue(key: string): string {
        let value: string = null;

        value = HardcodedLabels?.find(x => x.key === key)?.value;

        return value;
    }

}
